









































import mixins from 'vue-typed-mixins';
import { DataSet, DataSetContent } from '@/utils/DataSetUtils';
import OversightUtils, {
  OversightOrganizationType,
} from '@/utils/OversightUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Partial<DataSet>,
    },
  },

  computed: {
    oversighttypeOptions(): any {
      return this.oversighttypes?.map((oversighttype) => ({
        text: this.$translate(oversighttype.name),
        value: oversighttype,
      }));
    },
  },

  data(): {
    oversighttypes?: OversightOrganizationType[];
  } {
    return {
      oversighttypes: undefined,
    };
  },

  async mounted() {
    try {
      this.oversighttypes = await OversightUtils.api.type.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  watch: {
    oversighttypes() {
      if (this.value) {
        this.value.oversighttype = this.oversighttypes?.find(
          (oversighttype) => oversighttype.id === this.value?.oversighttype?.id
        );
      }
    },

    value() {
      if (this.value) {
        this.value.oversighttype = this.oversighttypes?.find(
          (oversighttype) => oversighttype.id === this.value?.oversighttype?.id
        );
      }
    },
  },

  methods: {},
});
